import React from 'react';

import { THUMB_STATE } from '../constants';
import Thumb from './Thumb';
import { Thumbs as ThumbsWrapper } from '../Form/Form.styled';

export default function Thumbs() {
  return (
    <ThumbsWrapper>
      <Thumb voteType={THUMB_STATE.UP} />
      <Thumb voteType={THUMB_STATE.DOWN} />
    </ThumbsWrapper>
  );
}
